import { object, number, string, union, literal, nativeEnum } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { Category_Restrictions } from '@occc/graphql';

export const productCategorySchema = object({
  name: string(),
  categoryRestriction: union([nativeEnum(Category_Restrictions), literal('None')]),
  rank: number().optional(),
});

export const validateProductCategory = makeValidate(productCategorySchema);
